// LinkedDatabaseView — BlockNote 커스텀 블록(Phase C).
// 노션 "링크된 DB 뷰"를 루트 본문에 인라인 임베드하기 위한 블록.
//
// - props.databaseId: 루트 database id(UUID). import 파이프라인 패스 2 에서
//   노션 hex → 루트 db id 로 치환되어 들어온다(notionDirect.js rewriteLinkedViews).
// - content: 'none' — 블록 내부에 편집 가능한 inline content 를 두지 않아
//   y-prosemirror 가 블록 내부를 추적하지 않게 한다(NodeView/Yjs 누수 방지).
// - 렌더는 Supabase db_* 테이블에서 독립 로드(DatabaseEmbed). Yjs 문서는 건드리지 않는다.

import { createReactBlockSpec } from '@blocknote/react';
import DatabaseEmbed from '../../database/DatabaseEmbed';

export const linkedDatabaseViewSpec = createReactBlockSpec(
  {
    type: 'linkedDatabaseView',
    propSchema: {
      databaseId: { default: '' },
    },
    content: 'none',
  },
  {
    render: ({ block }) => (
      <div contentEditable={false}>
        <DatabaseEmbed databaseId={block.props.databaseId} />
      </div>
    ),
  }
)();
// ⚠️ BlockNote 0.51.4: createReactBlockSpec(config, impl) 는 BlockSpec 객체가 아니라
//    "생성 함수" ((options?) => BlockSpec) 를 반환한다. 끝에 () 로 한 번 더 호출해야
//    실제 { config, implementation, extensions } 객체가 된다. 호출을 빠뜨리면 스키마
//    빌더가 함수의 .implementation.node 를 읽다 크래시("reading 'node' of undefined")
//    → 에디터 있는 전 페이지 백지. (2026-06-18 사고 → 런타임 재현·검증 후 수정)

export default linkedDatabaseViewSpec;
